(() => {
  const selector = '.money'
  const formattedClass = 'money--formatted'
  let frame

  const formatPrice = element => {
    if (!(element instanceof HTMLElement)) return
    if (element.classList.contains(formattedClass)) return
    if (element.children.length > 0) return

    const text = element.textContent.trim()
    const match = text.match(/^([€$£]\s*)?(-?\d{1,3}(?:[.\s]\d{3})*|-?\d+)([,.]\d{2})(\s*[A-Z]{3})?$/)

    if (!match) return

    const [, currency = '', euros, cents, currencyCode = ''] = match
    const fragment = document.createDocumentFragment()

    if (currency) {
      fragment.append(document.createTextNode(currency))
    }

    const eurosElement = document.createElement('span')
    eurosElement.className = 'money__euros'
    eurosElement.textContent = euros
    fragment.append(eurosElement)

    const centsElement = document.createElement('span')
    centsElement.className = 'money__cents'
    centsElement.textContent = cents
    fragment.append(centsElement)

    if (currencyCode) {
      const codeElement = document.createElement('span')
      codeElement.className = 'money__currency-code'
      codeElement.textContent = currencyCode
      fragment.append(codeElement)
    }

    element.replaceChildren(fragment)
    element.classList.add(formattedClass)
  }

  const formatPrices = root => {
    if (root instanceof HTMLElement && root.matches(selector)) {
      formatPrice(root)
    }

    if (root instanceof Element || root instanceof Document) {
      root.querySelectorAll(selector).forEach(formatPrice)
    }
  }

  const scheduleFormatting = root => {
    cancelAnimationFrame(frame)

    frame = requestAnimationFrame(() => {
      formatPrices(root)
    })
  }

  const initialize = () => {
    formatPrices(document)

    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.type === 'characterData') {
          const element = mutation.target.parentElement

          if (element?.matches(selector)) {
            element.classList.remove(formattedClass)
            scheduleFormatting(element)
          }

          return
        }

        mutation.addedNodes.forEach(node => {
          if (node instanceof Element) {
            scheduleFormatting(node)
          }
        })
      })
    })

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    })
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true })
  } else {
    initialize()
  }
})()